import $ from 'jquery';
import IMask from 'imask';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';
import validationRules from '../../common/utils/validation';

class ContactAgent {
    constructor() {
        this.scrollToOffset = $('header').height();
        this.scrollToElement = undefined;
        this.firstSubmit = false;
        this.valid = true;
        this.validPhone = false;
    }

    init() {
        this.bindEvents();
        this.setupInputmask();
        this.helpSelect();
        this.dateChooser();
    }

    dateChooser() {
        $('#date-chooser').on('change', (e) => {
            let val = $(e.target).val();
            if (val === '') {
                $(e.target).removeClass('has-value');
            } else {
                $(e.target).addClass('has-value');
            }
        });
    }

    helpSelect() {
        let opened = false;
        
        $('.js-help-select').on('change', (e) => {
            let selectedValue = e.target.value;
            $(e.target).addClass('selected-option');
            let rowDate = $('.row-date');
            if (selectedValue === 'I want to set up a meeting') {
                rowDate.removeClass('hidden');
            } else {
                rowDate.addClass('hidden');
            }
            $(e.target).blur();
        });
    }

    isClient() {
        let isClientEl = $('.is-client-js:checked').val();
        if (isClientEl === undefined) {
            $('.is-client .field-validation-error').removeClass('hidden');
            this.scrollToElement = '.is-client';
            this.valid = false;
        } else if (isClientEl === 'true' || isClientEl === 'false') {
            $('.is-client .field-validation-error').addClass('hidden');
        }
    }

    validateFirstName() {
        let firstName = $('#first-name').val();
        if (firstName === undefined || firstName === '') {
            $('#first-name ~ .field-validation-error').removeClass('hidden');
            $('#first-name').addClass('error');
            this.scrollToElement = $('#first-name');
            this.valid = false;
        } else {
            $('#first-name ~ .field-validation-error').addClass('hidden');
            $('#first-name').removeClass('error');
        }
    }

    validateLastName() {       
        let lastName = $('#last-name').val();
        if (lastName === undefined || lastName === '') {
            $('#last-name ~ .field-validation-error').removeClass('hidden');
            $('#last-name').addClass('error');
            this.scrollToElement = $('#last-name');
            this.valid = false;
        } else {
            $('#last-name ~ .field-validation-error').addClass('hidden');
            $('#last-name').removeClass('error');
        }
    }

    validateEmail() {
        let email = $('#email');
        if (email.val() === undefined || email.val() === '') {
            $('#email ~ .field-validation-error').html('Please enter your email address.');
            $('#email ~ .field-validation-error').removeClass('hidden');
            $('#email').addClass('error');
            this.scrollToElement = email;
            this.valid = false;
        } else if (!validationRules.emailValidate(email)) {
            $('#email ~ .field-validation-error').html('Please enter a valid email address.');
            $('#email ~ .field-validation-error').removeClass('hidden');
            $('#email').addClass('error');
            this.scrollToElement = email;
            this.valid = false;
        } else {
            $('#email ~ .field-validation-error').addClass('hidden');
            $('#email').removeClass('error');
        }
    }

    validatePhone() {
        if (this.validPhone === true) {
            $('#phone-number ~ .field-validation-error').addClass('hidden');
            $('#phone-number').removeClass('error');
        } else {
            this.scrollToElement = $('#phone-number');
            $('#phone-number ~ .field-validation-error').removeClass('hidden');
            $('#phone-number').addClass('error');
            this.valid = false;
        }
    }

    validateZip() {
        let zip = $('#zipcode');
        if (validationRules.zipValidate(zip)) {
            $('#zipcode ~ .field-validation-error').addClass('hidden');
            $('#zipcode').removeClass('error');
        } else {
            this.scrollToElement = zip;
            $('#zipcode ~ .field-validation-error').removeClass('hidden');
            $('#zipcode').addClass('error');
            this.valid = false;
        }
    }

    scrollToError() {
        if (this.scrollToElement !== undefined || this.scrollToOffset !== undefined) {
            $('html, body').animate({ scrollTop: $(this.scrollToElement).offset().top - this.scrollToOffset }, 750);
        }
    }

    doValidation() {
        // validate data in reverse verticle order => top most scrollToElement
        this.valid = true;  // try and make me false
        this.validateZip();
        this.validatePhone();
        this.validateEmail();
        this.validateLastName();
        this.validateFirstName();
        this.isClient();
        // scroll to 1st error
        if (this.valid === false) {
            if (this.firstSubmit === false) {
                this.firstSubmit = true;
                // add new events for better ux post 1st submit : realtime validation msging
                this.eventsAfterSubmitionFail();
            }
            this.scrollToError();
             return false;
        } else {
            return true;
        }
    }

    formatPhoneNumber(phoneNumberString) {
        let cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return null;
    }

    eventsAfterSubmitionFail() {    
        $('input[type=radio][name=IsClient]').change(() => this.isClient());
        $('#first-name').on('change keyup', () => this.validateFirstName());
        $('#last-name').on('change keyup', () => this.validateLastName());
        $('#email').on('change keyup', () => this.validateEmail());
        $('#phone-number').on('change keyup', () => this.validatePhone());
        $('#zipcode').on('change keyup', () => this.validateZip());
    }

    bindEvents() {
        $('.js-agent-contact').on('click', (e) => {
            e.preventDefault();
            if (this.doValidation()) {
                grecaptcha.ready(() => {
                  grecaptcha.execute($('g-recaptcha').data('sitekey'), { action: 'contactSubmit' }).then((token) => {
                        $('#g-recaptcha-response').val(token);
                        $('.js-agent-contact').attr('disabled', true);
                        $('.js-agent-contact').addClass('disabled');
                        $('.js-agent-contact').css('pointer-events', 'none');
                        document.querySelector('form.contact-agent-form').submit();
                    });
                });
            }
        });
        let phoneNumber = $('.contact-card.phone-icon .detail-phone a').html();
        let formattedPhone = this.formatPhoneNumber(phoneNumber);
        $('.contact-card.phone-icon .detail-phone a').html(formattedPhone);

        if ($('.contact-card.phone-icon .detail-cell a')) {
            let cellPhone = $('.contact-card.phone-icon .detail-cell a').html();
            let formattedCell = this.formatPhoneNumber(cellPhone);
            $('.contact-card.phone-icon .detail-cell a').html(formattedCell);
        }
    }

    setupInputmask() {
        let phoneSelector = document.getElementById('phone-number');
        let maskOptions = {
            mask: '(000) 000-0000'
        };
        let mask = IMask(phoneSelector, maskOptions);
        mask.on('accept', () => { this.validPhone = false; this.validatePhone(); });
        mask.on('complete', () => { this.validPhone = true; this.validatePhone(); });
    }
}

export default ContactAgent;

$(() => {
	const contactAgent = new ContactAgent();
	contactAgent.init();
});